(function(window, document) {
	'use strict';

	mint.on('documentLoaded', function() {
		const pageHeader = document.querySelector('.page-header');

		// Initialer Plugin-Aufruf
		mint.components.scrollOffset(pageHeader, {
			documentCssClass: 'is--page-header-fixed',
			offsetCssVariable: '--page-header-fixed-offset'
		});

		// setzen von Css-Klasse bei Aktivierung
		pageHeader.addEventListener('scroll-offset.activate', function() {
			pageHeader.classList.add('page-header--fixed');
		});

		// setzen von Css-Klasse bei Deaktivierung
		pageHeader.addEventListener('scroll-offset.deactivate', function() {
			pageHeader.classList.remove('page-header--fixed');
		});
	});
})(window, document);
